import { TextProps } from '../../atoms/Text';
import { RadioItemListProps } from '../../organisms/RadioItemList';


type RadioFieldInternalProps = {
  labelText?: TextProps;
  radioItemList?: RadioItemListProps;
};

type RadioFieldPropsValues = {
  '': RadioFieldInternalProps;
};

const propValues: RadioFieldPropsValues = {
  '': {
    labelText: {
      style: 'Regular',
      align: 'Left',
      colour: 'Default',
      type: 'Label2',
    },
    radioItemList: {
      type: 'Vertical',
    },
  },
};

const getProps = (type: string): RadioFieldInternalProps => {
  const values: RadioFieldInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
